import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import LiteralCurrency from 'components/LiteralCurrency';

const DiffInsured = ({ t, className, insuredQuantity }) => (
  <>
    {insuredQuantity ? (
      <div className={`${className}`}>
        <span>
          <Trans
            t={t}
            i18nKey="insured-edit"
            values={{ insuredQuantity }}
            components={[<LiteralCurrency value={insuredQuantity} />]}
          />
        </span>
      </div>
    ) : (
      <></>
    )}
  </>
);

DiffInsured.propTypes = {
  className: PropTypes.string.isRequired,
  insuredQuantity: PropTypes.number,
};

DiffInsured.defaultProps = {
  insuredQuantity: 0,
};

export default DiffInsured;
